/*
 * WARNING: This file was automatically generated.
 * Changes must be made to the package.templateroot, or they will be lost!
 */
export enum ILibraryContentItemType {
  Program = 'program',
  Workout = 'workout',
  General = 'general',
  LiveWorkout = 'live-workout',
  Section = 'section',
  Trainer = 'trainer',
  Challenge = 'challenge',
}
